<template>
  <sh-zapier-card content-path="/zapier-intro.html"/>
</template>

<script>
    import ZapierCard from "../../components/common/ZapierCard"
    export default {
        name : "App",
        props : {
            content_path : String,
        },
        components : {
            "sh-zapier-card" : ZapierCard
        },
    }
</script>

<style lang="sass">
  @import "../../styles/style"
</style>
